import React from 'react';
import { NumberInput, CheckBox, DropdownSelector } from 'hyperdb-utils';
import DayOfWeekPricesEditor from './DayOfWeekPricesEditor';

const DefaultPrice = ({ pricesData, priceRules, onChange, onChangePriceRules, errorBasePrice, showPayingChildren = false }) => {
  const handleClickVariability = () => {
    onChange('price_variability', { value: pricesData.price_variability ? 0 : 1});
  };
  return (
    <div>
      <div>
        <NumberInput
          label="Base price *"
          name="base_price"
          value={ pricesData.base_price }
          onChange={ onChange.bind(null, 'base_price') }
          error={ !pricesData.base_price && errorBasePrice ? errorBasePrice : null }
        />
        <NumberInput
          label="Fee per extra guest"
          name="base_extra"
          value={ pricesData.base_extra }
          onChange={ onChange.bind(null, 'base_extra') }
        />
      </div>
      <CheckBox
        label="Variable by day of the week"
        checked={ pricesData.price_variability }
        onChange={ handleClickVariability }
      />
      {
        !pricesData.price_variability ? null : (
          <DayOfWeekPricesEditor
            prices={ pricesData.day_of_week_prices || [] }
            defaultPrices={ pricesData }
            onChange={ onChange.bind(null, 'day_of_week_prices') }
          />
        )
      }
      {
        showPayingChildren
          ? <DropdownSelector
              label="Paying children"
              name="paying_children"
              value={ priceRules.paying_children || 1 }
              options={ payingChildrenOptions() }
              onChange={ onChangePriceRules.bind(null, 'paying_children') }
            />
          : null
      }
    </div>
  );
};

function payingChildrenOptions() {
  return [
    { name: 'all', value: 1 },
    { name: 'none', value: 2 },
    { name: '1/2', value: 3 },
    { name: '2/3', value: 4 },
  ];
}

export default DefaultPrice;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/DefaultPrice.jsx